import React from "react";

const Tabs = ({
  tabName,
  tabType,
  id,
  controls,
  target,
  ariaSelected,
  onClick,
}) => {
  return (
    <button
      className={tabType === "primary" ? "nav-link active" : "nav-link"}
      id={id}
      data-bs-toggle="tab"
      data-bs-target={target}
      type="button"
      role="tab"
      aria-controls={controls}
      aria-selected={ariaSelected}
      onClick={onClick}
      style={{fontSize : "18px"}}
    >
      {tabName}
    </button>
  );
};

export default Tabs;
